import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from './Sidebar';

export default function Layout() {
  const { user } = useSelector((s) => s.auth);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // user.company e texto livre do cadastro e envelhece (a pessoa troca de emprego e nao
  // volta no perfil). O vinculo da empresa que paga o plano e o dado atual, entao ele vem
  // primeiro; company continua como reserva para quem estuda por conta propria.
  const nomeDaEmpresa = user?.empresa?.nome || user?.company || '';

  return (
    <div>
      <div
        className={`sidebar-overlay${sidebarOpen ? ' show' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="main-content">
        <header className="topbar">
          <button className="hamburger-btn" onClick={() => setSidebarOpen(true)}>
            <i className="bi bi-list"></i>
          </button>
          <span className="topbar-brand">
            {nomeDaEmpresa ? (
              <>Olá, <strong>{user?.name?.split(' ')[0]}</strong> — {nomeDaEmpresa}</>
            ) : (
              <>Bem-vindo(a), <strong>{user?.name?.split(' ')[0]}</strong></>
            )}
          </span>
          <div className="topbar-right">
            <span className="topbar-user" style={{ gap: 8 }}>
              <span
                style={{
                  width: 30, height: 30, borderRadius: '50%',
                  background: 'var(--gold)', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', color: '#fff', fontSize: 12, fontWeight: 600,
                }}
              >
                {user?.avatarInitials || user?.name?.substring(0, 2).toUpperCase()}
              </span>
            </span>
          </div>
        </header>

        <div className="page-content fade-in">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
